import { render, staticRenderFns } from "./threePieData.vue?vue&type=template&id=74f5af5a&"
import script from "./threePieData.vue?vue&type=script&lang=js&"
export * from "./threePieData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports